import { Navigate, Outlet } from 'react-router-dom'
import { useMe } from '@/api/hooks'

/**
 * Auth gate for the whole app shell. Until `/api/v1/me` resolves we render a
 * neutral splash (never the protected UI), so an unauthenticated visitor lands
 * straight on /login with no flash of app chrome. On 401 (or no user) we
 * redirect immediately; the axios interceptor is the belt-and-braces fallback
 * for sessions that expire mid-use.
 */
export function RequireAuth() {
  const { data: me, isPending, isError } = useMe()

  if (isPending) {
    return <AuthSplash />
  }

  if (isError || !me) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}

/** Full-screen neutral loading state shown only while auth is resolving. */
function AuthSplash() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-screen items-center justify-center bg-subtle"
    >
      <span className="sr-only">Loading</span>
      <span
        className="h-8 w-8 animate-spin rounded-full border-2 border-border border-t-brand"
        aria-hidden
      />
    </div>
  )
}
